import React, { useEffect, useMemo, useState } from "react";
import "./CredentialManagement.scss";
import { Button } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { Input, Label } from "reactstrap";
import { ApiPost } from "../../../../helpers/API/ApiData";
import { toast } from "react-toastify";
import Select from "react-select";

function AddLeadDetails(props) {
  const { inputValue, setInputValue, handleChange, errors,setError, formType, handleAddNews, loading, handleOnClose } = props;
  // const [cityName, setCityName] = useState();
  // const [selectedCity, setSelectedCity] = useState([]);

  const bindInput = (value) => {
    var regex = new RegExp("^[^0-9]*$");
    var key = String.fromCharCode(
      !value.charCode ? value.which : value.charCode
    );
    if (regex.test(key)) {
      value.preventDefault();
      return false;
    }
  };

  // const handleOnChanges = (selectedProject, name) => {
  //     setSelectedCity(selectedProject);
  //     setInputValue({ ...inputValue, ort: selectedProject.value });
  //     setError({ ...errors, ort: "" });
  // };

  // useEffect(() => {
  //   const handleGetPostalCode = async () => {
  //     await ApiPost(`vattenfall/getPostalcode`)
  //     // await ApiGet(`vattenfall/getPostalcode?page=${page}&limite=${limit}&search=${search}`)
  //       .then((response) => {
  //         const data = response?.data?.payload;
  //         const optionData = data?.map((item) => ({
  //           value: item._id,
  //           label: item.cityName,
  //         }));
  //         setCityName(optionData);
  //       })
  //       .catch((error) => {
  //         toast.error(error);
  //       });
  //   };
  //   handleGetPostalCode();
  // }, []);

  // useEffect(() =>{
  //   const updatedCity = cityName?.filter((ele) => {
  //     if (
  //       inputValue?.ort === ele?.value
  //     ) {
  //       return ele?.label;
  //     }
  //   });
  //   setSelectedCity(updatedCity);
  // }, [cityName])

  return (
    <div className="modal-content new-model-conent-sye">
      <Modal.Header className="justify-content-start d-flex align-items-center" closeButton>
        <Modal.Title style={{ color: "#D7365A" }}>{formType == "add" ? "Leads hinzufügen" : "Leads aktualisieren"} </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{height: "auto"}}>
        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="name">
              Anrede 
              {/* <span className="text-danger">*</span> */}
            </Label>
            <Input placeholder="Anrede" name="anrede" value={inputValue?.anrede} onChange={(event) => handleChange(event, "input")} invalid={errors?.anrede && "true"} />
            {/* <span className="errors">{errors?.anrede}</span> */}
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Vorname">
              Vorname
               {/* <span className="text-danger">*</span> */}
            </Label>
            <Input placeholder="Vorname" name="vorname" value={inputValue?.vorname} onChange={(event) => handleChange(event, "input")} invalid={errors?.vorname && "true"} />
            {/* <span className="errors">{errors?.vorname}</span> */}
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Nachname">
              Nachname
               {/* <span className="text-danger">*</span> */}
            </Label>
            <Input placeholder="Nachname" name="nachname" value={inputValue?.nachname} onChange={(event) => handleChange(event, "input")} invalid={errors?.nachname && "true"} />
            {/* <span className="errors">{errors?.nachname}</span> */}
          </div>
        </div>

        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Firma">
              Firma <span className="text-danger">*</span>
            </Label>
            <Input placeholder="Firma" name="firma" value={inputValue?.firma} onChange={(event) => handleChange(event, "input")} invalid={errors?.firma && "true"} />
            <span className="errors">{errors?.firma}</span>
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Adresse">
              Adresse <span className="text-danger">*</span>
            </Label>
            <Input placeholder="Adresse" name="adresse" value={inputValue?.adresse} onChange={(event) => handleChange(event, "input")} invalid={errors?.adresse && "true"} />
            <span className="errors">{errors?.adresse}</span>
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Postleitzahl">
              Postleitzahl <span className="text-danger">*</span>
            </Label>
            <Input placeholder="Postleitzahl" name="postleitzahl" onKeyPress={bindInput} value={inputValue?.postleitzahl} onChange={(event) => handleChange(event, "input")} invalid={errors?.postleitzahl && "true"} />
            <span className="errors">{errors?.postleitzahl}</span>
          </div>
        </div>

        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Ort">
              Ort <span className="text-danger">*</span>
            </Label>
            <Input placeholder="Ort" name="ort" value={inputValue?.ort} onChange={(event) => handleChange(event, "input")} invalid={errors?.ort && "true"} />
            {/* <Select
                className="dropdown-align "
                value={selectedCity}
                onChange={(e) => handleOnChanges(e, "ort")}
                options={cityName}
                // isMulti
                maxHeight={"100px"}
                // styles={customStyles}
                defaultValue={selectedCity}
                
              /> */}
            <span className="errors">{errors?.ort}</span>
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Kontakt">
              Kontakt 
              {/* <span className="text-danger">*</span> */}
            </Label>
            <Input placeholder="Kontakt" name="kontakt" onKeyPress={bindInput} value={inputValue?.kontakt} onChange={(event) => handleChange(event, "input")} invalid={errors?.kontakt && "true"} />
            {/* <span className="errors">{errors?.kontakt}</span> */}
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="E-mail">
              E-mail
               {/* <span className="text-danger">*</span> */}
            </Label>
            <Input placeholder="E-mail" name="eMail" value={inputValue?.eMail} onChange={(event) => handleChange(event, "input")} invalid={errors?.eMail && "true"} />
            <span className="errors">{errors?.eMail}</span>
          </div>
        </div>
        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="website">
                Webseite 
            </Label>
            <Input placeholder="website" name="website" value={inputValue?.website} onChange={(event) => handleChange(event, "input")} invalid={errors?.website && "true"} />
            <span className="errors">{errors?.website}</span>
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="numberOfEmployees">
              Anzahl der Mitarbeiter 
            </Label>
            <Input placeholder="numberOfEmployees" name="numberOfEmployees" value={inputValue?.numberOfEmployees} onChange={(event) => handleChange(event, "input")} invalid={errors?.numberOfEmployees && "true"} />
            <span className="errors">{errors?.numberOfEmployees}</span>
          </div>
          <div className="col-4 col-md-4">
          <div style={{ display: "flex", alignItems: "start", flexDirection:"column", gap: "10px" }}>
                  {/* Label */}
                  <label >Entscheidungsträger erreicht:</label>

                  {/* Radio Buttons Wrapper */}
                  <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    {/* Yes Option */}
                    <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                      <input type="radio" id="decision-yes" name="decisionMakerReached" value="yes" checked={inputValue?.decisionMakerReached === "yes"} onChange={(event) => handleChange(event, "input")} />
                      Yes
                    </label>

                    {/* No Option */}
                    <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                      <input type="radio" id="decision-no" name="decisionMakerReached" value="no" checked={inputValue?.decisionMakerReached === "no"} onChange={(event) => handleChange(event, "input")} />
                      No
                    </label>
                  </div>
                </div>
          </div>
          
        </div>
        
        <div className="row">
          {/* <div className="col-4 col-md-4"> */}
          <div className="wichtige-Informationen-textarea-main">
            <Label className="form-label" for="importantInfo">
              wichtige Informationen
               {/* <span className="text-danger">*</span> */}
            </Label>
            <div style={{display:"flex", flexDirection:"column"}}>
            <textarea placeholder="wichtige Informationen" name="importantInfo" value={inputValue?.importantInfo} onChange={(event) => handleChange(event, "input")} invalid={errors?.importantInfo && "true"} />
            {/* <span className="errors">{errors?.importantInfo}</span> */}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="activebutton h-40px" onClick={handleOnClose} style={{ marginRight: "15px" }}>
          Abbrechen
        </Button>
        <Button disabled={loading} className="addbutton" onClick={handleAddNews}>
          <span>{formType == "add" ? " Speichern" : "aktualisieren"}</span>
          {loading && <div class="h-20px spinner-border text-light w-20px ml-2"></div>}
        </Button>
      </Modal.Footer>
    </div>
  );
}

export default AddLeadDetails;
